const datasets_params = {
    'task': 'classification',
    'classification_model': 'GPT2',
    'num_labels': 1,
    'num_classes': 2,
    'batch_size': 16,
    'learning_rate_left': 5,
    'learning_rate_right': 3,
    'epochs_num': 3,
    'warmup': 1,
    'dataset_selection': 'hf',
    'dataset_value': 'bla3',
    'metrics': ['precision', 'accuracy', 'recall'],
    'new_model_name': 'my best model2!',
    'client_id': '40b3a00e282ee2db1338c3bba881b99125fc3ba1d7f5c29232ce1ad63fab1e75',
    'model_saved_path': './OPTUNE.ai'
}

export default function get_default_datasets_table_data() {

    return [
        {
            key: '0',
            new_dataset_name: 'customer-support-chatbot',
            created_at: '2024-05-13-10:40:03',
            entries_num: 526525,
            db_size: "359",
            datasets_params: datasets_params,
            task: "Chat",
            application: "Customer Support Charbot",
            finetuning_type: true,
        },
        {
            key: '1',
            new_dataset_name: 'customer-support-q&a',
            created_at: '2023-02-02-11:32:10',
            entries_num: 53691241,
            db_size: "456",
            datasets_params: datasets_params,
            task: "Q & A",
            application: "Customer Support Q & A",
            finetuning_type: true,
        },
        {
            key: '2',
            new_dataset_name: 'customer-review-summarization',
            created_at: '2023-02-02-11:32:10',
            entries_num: 92361,
            db_size: "670",
            datasets_params: datasets_params,
            task: "Summarization",
            application: "Customer Review Summarization",
            finetuning_type: true,
        },
        {
            key: '3',
            new_dataset_name: 'status-update-classification',
            created_at: '2023-02-02-11:32:10',
            entries_num: 16523,
            db_size: "263",
            datasets_params: datasets_params,
            task: "Classification",
            application: "Status Update Classification",
            finetuning_type: true,
        },
        {
            key: '4',
            new_dataset_name: "internal-mail",
            created_at: '2023-02-02-11:32:10',
            entries_num: 16523,
            db_size: "263",
            datasets_params: datasets_params,
            task: "Classification",
            application: "Status Update Classification",
            finetuning_type: false,
        },
        {
            key: '5',
            new_dataset_name: "internal-slack",
            created_at: '2023-02-02-11:32:10',
            entries_num: 16523,
            db_size: "263",
            datasets_params: datasets_params,
            task: "Classification",
            application: "Status Update Classification",
            finetuning_type: false,
        },
        {
            key: '6',
            new_dataset_name: "internal-confluence",
            created_at: '2023-02-02-11:32:10',
            entries_num: 16523,
            db_size: "263",
            datasets_params: datasets_params,
            task: "Classification",
            application: "Status Update Classification",
            finetuning_type: false,
        },
        {
            key: '7',
            new_dataset_name: "medical-terms",
            created_at: '2023-02-02-11:32:10',
            entries_num: 16523,
            db_size: "263",
            datasets_params: datasets_params,
            task: "Classification",
            application: "Status Update Classification",
            finetuning_type: false,
        },
        {
            key: '8',
            new_dataset_name: "finance-terms",
            created_at: '2023-02-02-11:32:10',
            entries_num: 16523,
            db_size: "263",
            datasets_params: datasets_params,
            task: "Classification",
            application: "Status Update Classification",
            finetuning_type: false,
        },


    ]
}